// extracted by mini-css-extract-plugin
module.exports = {"movie":"Movie_movie__27rBX"};